export const Urls = {
    sendOtp:'/v1/send-otp',
    sendSoftpullOtp:'/v1/send-softpull-otp',
    verifySoftpullOtp:'/v1/verify-softpull-otp',
    generateCibilReportLink:'/v1/generate-cibil-report-link',
    verifyOtp:'/v1/verify-otp',
    userDetails:'/v1/user/details',
    getMandateModes:'/v1/mandate/modes',
    createUpiMandate:'/v1/mandate/upi',
    mandateStatus:'/v1/mandate/status',
    createDebitCardMandate:'/v1/mandate/emandate',
    bankDetails:'/v1/bankname',
    wrongDetails:'v1/status/wrong-details',
};